import React from 'react';
import { AppProvider } from '../context/AppProvider';


export const RootElement = ({ children }) => {
    return (
        <AppProvider>
            {/* <MusicProvider> */}
            {children}
            {/* </MusicProvider> */}
        </AppProvider>
    );
};

// module.exports = RootElement;
// export default RootElement;